import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, switchMap, map, catchError, flatMap } from 'rxjs/operators';

import * as AccountActions from './account.actions';
import * as fromShared from '../../shared';
import { AccountService } from '../account.service';
import { DisplayMessageMinimum, ResponseStatus } from '../../shared';

@Injectable()
export class AccountEffects {
    getAccounts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountActions.getAccounts),
            switchMap(action =>
                this.service.get(action.AccountType, action.LaborType).pipe(
                    flatMap(resp => [
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        r =>
                                            r.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        ),
                        AccountActions.loadAccounts({
                            accounts: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    getContractARAccounts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountActions.getContractARAccounts),
            switchMap(() =>
                this.service.getContractARAccounts().pipe(
                    flatMap(resp => [
                        AccountActions.loadContractARAccounts({
                            contracts: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    putContractARAccountsStatus$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountActions.putContractARAccounts),
            map(action =>
                AccountActions.updateContractARAccounts({
                    contracts: action.contracts.map(x => ({
                        ...x,
                        Status: {
                            StatusCode: ResponseStatus.Loading,
                            Message: 'Loading'
                        }
                    }))
                })
            )
        );
    });
    putContractARAccounts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountActions.putContractARAccounts),
            switchMap(action =>
                this.service.putContractARAccounts(action.contracts).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  AccountActions.updateContractARAccounts({
                                      contracts: resp.Items
                                  }),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.Contractlistid.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  AccountActions.updateContractARAccounts({
                                      contracts: resp.Items
                                  })
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    constructor(private actions$: Actions, private service: AccountService) {}
}
